import { Modal } from '../../../../../../core/components/templates/Modal';
import Player from '../../../../../../core/components/molecules/Player';
import { MODAL_VIDEOS_VIMEO_ALLOWED } from '../../../../../../core/constants/modal-videos';

interface AboutThemesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function AboutThemesModal({ isOpen, onClose }: AboutThemesModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size='md'
      title='Saiba mais sobre a Área de Redação?'
    >
      <Player
        playerType='vimeo'
        className='h-[265px]'
        token={MODAL_VIDEOS_VIMEO_ALLOWED.TEMAS_REDACAO.token}
        initialTime={0}
      />
    </Modal>
  );
}

export { AboutThemesModal };
